(() => {
  const callback = () => {
    const selectors = {
      bubble: '.cart-link__bubble--with-count',
    };

    const bubble = document.querySelector(selectors.bubble);
    if (!bubble) return;

    const onCartRenderHandler = (event) => {
      const { cart } = event.detail ?? {};
      if (!cart) return;

      const itemsCount = cart.item_count || (cart.items ?? []).length;
      bubble.innerHTML = itemsCount;
    };

    document.addEventListener('cart:markup-built', onCartRenderHandler);
  };

  window.addEventListener('DOMContentLoaded', callback);
})();
